import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UserService } from 'src/app/_share/_services/user.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  passwordResetForm: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  resetRequested: boolean = false;
  currentUserEmail: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private messageService: MessageService
  ) {
    this.passwordResetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    // Get current user's email
    this.userService.currentUser$.subscribe((user) => {
      if (user && user.email) {
        this.currentUserEmail = user.email;
        this.passwordResetForm.patchValue({
          email: user.email
        });
      }
    });
  }

  get f() {
    return this.passwordResetForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.passwordResetForm.invalid) {
      return;
    }

    this.loading = true;
    const email = this.f['email'].value;

    this.userService.forgotPassword(email).subscribe({
      next: (response) => {
        this.loading = false;
        this.resetRequested = true;
        this.messageService.add({
          severity: 'success',
          summary: 'Password Reset Requested',
          detail: 'A password reset link has been sent to your email address.',
          life: 5000
        });
      },
      error: (error) => {
        this.loading = false;
        console.error('Password reset error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error?.detail || 'Failed to request password reset. Please try again.',
          life: 5000
        });
      }
    });
  }

  resetForm(): void {
    this.submitted = false;
    this.resetRequested = false;
    this.passwordResetForm.reset();
    if (this.currentUserEmail) {
      this.passwordResetForm.patchValue({
        email: this.currentUserEmail
      });
    }
  }
}
